// extracted by mini-css-extract-plugin
var _1 = "PostLayout-module__animateUploadProgressBarWidth--JboSO";
var _2 = "PostLayout-module__animatedBackground--B9ev3";
var _3 = "PostLayout-module__hasBanner--jaIws";
var _4 = "PostLayout-module__isHidden--xQWOF";
var _5 = "PostLayout-module__isMagneticWallExpanded--T4pqi";
var _6 = "PostLayout-module__isTOCExpanded--glEVK";
var _7 = "PostLayout-module__mobile--rx8MK";
var _8 = "PostLayout-module__monitor--SDeyP";
var _9 = "PostLayout-module__postLayoutAbove--sX5i4";
var _a = "PostLayout-module__postLayoutAboveInner--g0ueD";
var _b = "PostLayout-module__postLayoutBanner--jJBpL";
var _c = "PostLayout-module__postLayoutBannerControls--tjvgd";
var _d = "PostLayout-module__postLayoutBelow--d5WfP";
var _e = "PostLayout-module__postLayoutContainer--PEFC8";
var _f = "PostLayout-module__postLayoutControlBar--J1tTj";
var _10 = "PostLayout-module__postLayoutEditor--zFVAl";
var _11 = "PostLayout-module__postLayoutFooterControlBar--DHKEH";
var _12 = "PostLayout-module__postLayoutGutter--rNbUu";
var _13 = "PostLayout-module__postLayoutMagneticWall--fJQy5";
var _14 = "PostLayout-module__postLayoutRoot--cODGj";
var _15 = "PostLayout-module__postLayoutStateBar--risQQ";
var _16 = "PostLayout-module__postLayoutStateBarInner--ZSYPn";
var _17 = "PostLayout-module__postLayoutStateBarRightContent--gkEhq";
var _18 = "PostLayout-module__postLayoutTOC--XFiZa";
var _19 = "PostLayout-module__readOnly--NL5wC";
var _1a = "PostLayout-module__tablet--B7ZKb";
var _1b = "PostLayout-module__withExtraBottomPadding--yS4nz";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "hasBanner", _4 as "isHidden", _5 as "isMagneticWallExpanded", _6 as "isTOCExpanded", _7 as "mobile", _8 as "monitor", _9 as "postLayoutAbove", _a as "postLayoutAboveInner", _b as "postLayoutBanner", _c as "postLayoutBannerControls", _d as "postLayoutBelow", _e as "postLayoutContainer", _f as "postLayoutControlBar", _10 as "postLayoutEditor", _11 as "postLayoutFooterControlBar", _12 as "postLayoutGutter", _13 as "postLayoutMagneticWall", _14 as "postLayoutRoot", _15 as "postLayoutStateBar", _16 as "postLayoutStateBarInner", _17 as "postLayoutStateBarRightContent", _18 as "postLayoutTOC", _19 as "readOnly", _1a as "tablet", _1b as "withExtraBottomPadding" }
